import { useI18n } from '../contexts/I18nContext';
import { uiLocale } from './tz';

export function useRelativeTime() {
  const { t } = useI18n();
  return (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return t('just_now');
    const pre = t('rel_prefix') ? `${t('rel_prefix')} ` : '';
    if (diff < 3600) return `${pre}${Math.floor(diff / 60)} ${t('min_ago')}`;
    if (diff < 86400) return `${pre}${Math.floor(diff / 3600)} ${t('h_ago')}`;
    return `${pre}${Math.floor(diff / 86400)} ${t('d_ago')}`;
  };
}

export function formatDateTime(iso, lang = 'en') {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(uiLocale(lang), {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

// "14:05" when today, else "28 Oct, 14:05" — in the viewer's timezone.
export function formatSince(iso, lang = 'en') {
  if (!iso) return '—';
  return new Date(iso).toDateString() === new Date().toDateString() ? formatTime(iso, lang) : formatDateTime(iso, lang);
}

export function formatTime(iso, lang = 'en') {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleTimeString(uiLocale(lang), { hour: '2-digit', minute: '2-digit' });
}
